import { FC } from 'react';
import { MeQuery, SubscriptionStatus } from 'lib/home/generated/types/api';
import { useOrdersQuery } from 'lib/home/generated/queries';
import { CurrentOrder, DefaultLayout, Loading, PleaseReturn, UpcomingOrders } from '../components';

const DashboardPage: FC = () => {
  const { data: orders } = useOrdersQuery();

  if (!orders || !orders.me.subscription)
    return (
      <DefaultLayout>
        <Loading />
      </DefaultLayout>
    );

  return (
    <DefaultLayout>
      {({ me }: { me: MeQuery['me'] }) => {
        const { first_name, last_name } = me;
        const { subscription } = orders.me;
        const { current_order, upcoming_orders } = subscription;

        if (!subscription || (subscription?.status !== SubscriptionStatus.Cancelled && !current_order))
          return <Loading />;

        if (subscription?.status === SubscriptionStatus.Cancelled)
          return <PleaseReturn names={{ first_name, last_name }} />;

        return (
          <>
            <CurrentOrder me={me} orders={orders} />
            {subscription.status !== SubscriptionStatus.Paused && (
              <UpcomingOrders upcomingOrders={upcoming_orders} subscriptionTitle={subscription.product_variant.title} />
            )}
          </>
        );
      }}
    </DefaultLayout>
  );
};

export default DashboardPage;
